import type { PostDestinationId } from '../../lib/publishing/destinations';
import {
  destinationsWithOwnCaption,
  frozenCaptionSummary,
} from '../../lib/publishing/captionOverride';
import type { ComposerTarget } from './composerState';

// The frozen-copy warning at the top of the composer, beside the main caption
// (Scott, 2026-09-30 — "on both": here AND on the destination's own block).
// Someone editing the main caption is looking HERE, not at a collapsed block
// further down, so this is where the consequence has to be stated. The wording
// is src/lib/publishing/captionOverride.ts's, asserted there.
export function FrozenCaptionNotice({
  targets,
}: {
  targets: Record<PostDestinationId, ComposerTarget>;
}) {
  const text = frozenCaptionSummary(destinationsWithOwnCaption(targets));
  if (!text) return null;
  return (
    <p className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
      {text}
    </p>
  );
}
